import { render } from "./WizardEntrancePlant.vue?vue&type=template&id=6a941a97&ts=true"
import script from "./WizardEntrancePlant.ts?vue&type=script&lang=ts"
export * from "./WizardEntrancePlant.ts?vue&type=script&lang=ts"

import "./WizardEntrancePlant.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__